export const getAdjacentDiagrams = (diagrams = [], sectionCode = '') => {
  const currentIndex = diagrams.findIndex(
    (diagram) => String(diagram?.sectionCode) === String(sectionCode)
  );

  if (currentIndex < 0) {
    return { previousDiagram: null, nextDiagram: null };
  }

  return {
    previousDiagram: currentIndex > 0 ? diagrams[currentIndex - 1] : null,
    nextDiagram: currentIndex < diagrams.length - 1 ? diagrams[currentIndex + 1] : null,
  };
};
